export type ServiceInterfaceFiltersMessages = {
  platformNameLabel: string;
  descriptionLabel: string;
  isActiveLabel: string;
  situationFilterLabel: string;
  executionHistoryFilterLabel: string;
  lastExecutionFromLabel: string;
  lastExecutionToLabel: string;
  allOption: string;
  yesOption: string;
  noOption: string;
  runningOption: string;
  pausedOption: string;
  errorOption: string;
  successOption: string;
  clearFilterButton: string;
  filterButton: string;
  moreFiltersButton: string;
  lessFiltersButton: string;
};

export const SERVICE_INTERFACE_FILTERS_MESSAGES: ServiceInterfaceFiltersMessages = {
  platformNameLabel: "Plataforma",
  descriptionLabel: "Descrição do serviço",
  isActiveLabel: "Ativo",
  situationFilterLabel: "Situação",
  executionHistoryFilterLabel: "Desempenho",
  lastExecutionFromLabel: "Última execução (de)",
  lastExecutionToLabel: "Última execução (até)",
  allOption: "Todos",
  yesOption: "Sim",
  noOption: "Não",
  runningOption: "Em execução",
  pausedOption: "Em pausa",
  errorOption: "Erros",
  successOption: "Sucessos",
  clearFilterButton: "Limpar filtros",
  filterButton: "Filtrar",
  moreFiltersButton: "Mais filtros",
  lessFiltersButton: "Menos filtros",
};
